import { useEffect } from 'react';
import { reserveBasPage } from '../utils/reserveBasPage';

/**
 * Enveloppe du coin bas-droite, et la reserve de place qui va avec.
 *
 * POURQUOI ELLE EXISTE. Le positionnement flottant vivait dans
 * `TableExportButton`. Le jour ou un deuxieme bouton a du flotter - l'export
 * serveur des etats partenaires, qui ne passe pas par ce composant - il aurait
 * fallu recopier les quatre valeurs de position ET ne pas oublier la reserve de
 * place. Une position recopiee derive ; une reserve oubliee masque la fin d'un
 * tableau.
 *
 * CE QU'ELLE GARANTIT. Tout ce qui flotte au meme coin flotte au MEME endroit, et
 * reserve sa place en bas de page le temps qu'il est monte. La reserve compte ses
 * porteurs : deux boutons flottants sur un meme ecran ne se liberent pas l'un
 * l'autre.
 */
export default function BoutonFlottant({ children }) {
  useEffect(() => reserveBasPage.reserver(), []);

  return (
    <div style={{ position: 'fixed', ...COIN_FLOTTANT }}>
      {children}
    </div>
  );
}

/**
 * La geometrie du coin, exportee pour que ce qui doit s'EMPILER au-dessus n'ait pas a
 * recopier ces valeurs.
 *
 * <p>C'est la lecon du commentaire ci-dessus, appliquee a un second cas : le panneau de
 * discussion d'un dossier flotte au meme coin, et doit se poser au-dessus du bouton
 * d'export sans le recouvrir. Recopier `right: 32` la-bas, c'etait deux valeurs a tenir
 * en accord - et la collision ne se voit que sur un ecran qui porte les deux.
 */
export const COIN_FLOTTANT = { right: 32, bottom: 32, zIndex: 1000 };

/** Hauteur d'un bouton flottant (AntD `size="large"`), plus l'air autour. */
export const HAUTEUR_BOUTON_FLOTTANT = 40;

/** Le `bottom` d'un element qui s'empile juste au-dessus du coin flottant. */
export const BOTTOM_AU_DESSUS_DU_COIN =
  COIN_FLOTTANT.bottom + HAUTEUR_BOUTON_FLOTTANT + 12;

/** L'allure d'un bouton flottant : ombre portee et coins arrondis. */
export const STYLE_BOUTON_FLOTTANT = {
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
  borderRadius: 8,
};
